<vs-dialog [config]="{ dialogContainerClass: 'w-[350px] sm:w-[520px] max-w-[90%] max-h-[90%]' }">
  <vs-dialog-header
    class="self-start w-full"
    [config]="{
      mode: 'simple',
      icon: 'coins-swap-01',
      iconTheme: 'primary',
      title: 'Split Payment',
      subtitle: 'Divide the net payable between the repair shop and the customer.',
      showDivider: true
    }"
  ></vs-dialog-header>

  <form [formGroup]="form" class="flex flex-col gap-4 w-full mt-4" (keydown.enter)="$event.preventDefault()">
    <dl *ngIf="authorization" class="flex flex-col gap-1 text-sm border rounded-xl px-4 py-3">
      <div class="flex justify-between">
        <dt class="text-gray-500">Authorization</dt>
        <dd>{{ authorization.reference }}</dd>
      </div>
      <div class="flex justify-between font-semibold text-gray-900">
        <dt>Net payable</dt>
        <dd>{{ formatAmount(netPayable) }}</dd>
      </div>
    </dl>

    <vs-form-field appearance="responsive" [config]="{ label: 'Repair shop' }">
      <input
        vsInput
        type="text"
        formControlName="shop"
        placeholder="$0.00"
        currencyMask
        [options]="currencyMaskConfig"
        [attr.disabled]="shopName ? null : true"
      />
      <div slot="hint" class="flex items-center justify-between gap-2">
        <span>{{ shopName ?? 'Assign a repair shop to pay the shop.' }}</span>
        <button
          *ngIf="shopName && remaining > 0"
          vs-button
          type="button"
          appearance="clear"
          size="xs"
          (click)="fillRemaining('shop')"
        >
          Add the rest
        </button>
      </div>
    </vs-form-field>

    <vs-form-field appearance="responsive" [config]="{ label: 'Customer' }">
      <input
        vsInput
        type="text"
        formControlName="customer"
        placeholder="$0.00"
        currencyMask
        [options]="currencyMaskConfig"
      />
      <div slot="hint" class="flex items-center justify-between gap-2">
        <span>{{ customerName ?? 'Contract holder' }}</span>
        <button
          *ngIf="remaining > 0"
          vs-button
          type="button"
          appearance="clear"
          size="xs"
          (click)="fillRemaining('customer')"
        >
          Add the rest
        </button>
      </div>
    </vs-form-field>

    <!-- Running total against the net payable -->
    <div
      class="flex items-center justify-between gap-2 rounded-xl px-4 py-3 text-sm"
      [class.bg-success-50]="remaining === 0"
      [class.text-success-700]="remaining === 0"
      [class.bg-warn-50]="remaining > 0"
      [class.text-warn-700]="remaining > 0"
      [class.bg-danger-50]="remaining < 0"
      [class.text-danger-700]="remaining < 0"
    >
      <span>Allocated {{ formatAmount(allocated) }} of {{ formatAmount(netPayable) }}</span>
      <span class="font-semibold">
        {{ remaining === 0 ? 'Fully allocated' : remaining > 0 ? formatAmount(remaining) + ' left' :
        formatAmount(-remaining) + ' over' }}
      </span>
    </div>

    <div class="flex flex-col-reverse sm:flex-row sm:justify-end gap-3 pt-2">
      <button
        vs-button
        type="button"
        appearance="outline"
        class="w-full sm:w-auto"
        [disabled]="saving"
        (click)="close()"
      >
        Cancel
      </button>

      <button
        vs-button
        type="button"
        theme="primary"
        class="w-full sm:w-auto"
        [disabled]="saving || !isValid"
        (click)="submit()"
      >
        Save split
      </button>
    </div>
  </form>
</vs-dialog>
